import React from 'react';
import './conversation-list-content.scss';
import { ConversationsModalGroup } from '../conversations-modal-group/conversations-modal-group';
import { useGetCommonConverationFunctions } from '../hooks/get-common-conversation-functions';
import { useGetConversationList } from '../hooks/get-conversation-list';
import { ConversationList } from './conversation-list';
import { ChipFilters } from '../../components';
import { Toast } from '../../components/toast/toast';

interface ConversationListContentProps {
  filterPage?: string;
  setFilterPage?: React.Dispatch<React.SetStateAction<string>>;
  showFilter?: boolean;
  setShowFilter?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ConversationListContent: React.FC<
  ConversationListContentProps
> = ({
  filterPage = '',
  setFilterPage = () => {},
  showFilter = false,
  setShowFilter = () => {},
}) => {
  const onDateChipPress = () => {
    setFilterPage('DateRange');
    setShowFilter(true);
  };

  const {
    conversationsData,
    onScroll,
    lastItemRef,
    isPageLoading,
    isLoading,
    updateConversations,
    refetchConversationList,
    isEndOfList,
    chips,
    mergedFunnelGroupMap,
  } = useGetConversationList({ onDateChipPress });

  const {
    findStatusCategory,
    onActionPress,
    modalState,
    onCloseModal,
    findTagType,
  } = useGetCommonConverationFunctions();

  return (
    <div className="conversation-list-content">
      {chips && (
        <ChipFilters
          sections={chips}
          chipFilterStyles={{
            alignSelf: 'flex-start',
            width: '100%',
            position: 'sticky',
            top: 0,
            left: 0,
          }}
        />
      )}
      <ConversationList
        data={conversationsData}
        onActionPress={onActionPress}
        onScroll={onScroll}
        lastItemRef={lastItemRef}
        isPageLoading={isPageLoading}
        isLoading={isLoading}
        findStatusCategory={findStatusCategory}
        findTagType={findTagType}
        isEndOfList={isEndOfList}
        onRefresh={refetchConversationList}
        mergedFunnelGroupMap={mergedFunnelGroupMap}
      />
      <ConversationsModalGroup
        modalState={modalState}
        onCloseModal={onCloseModal}
        updateConversations={updateConversations}
        refetchConversationList={refetchConversationList}
        onActionPress={onActionPress}
        findTagType={findTagType}
        filterState={{
          open: showFilter,
          page: filterPage ?? '',
          close: () => setShowFilter(false),
        }}
      />
      <Toast />
    </div>
  );
};
